import { Box, styled } from "@mui/material"

const ScheduleMeetingDialogContent = styled(Box)({
  display: "flex",
  flexFlow: "column nowrap",
  alignContent: "stretch",

  paddingLeft: 20,
  paddingRight: 20,
  overflow: "hidden",
}) as typeof Box

export default ScheduleMeetingDialogContent
